Object.defineProperty(exports, "__esModule", { value: true });
exports.SvgBattery = void 0;
const core_1 = require("@emotion/core");
const styled_system_1 = require("@wheelroom/styled-system");
const componentId = 'svg-battery';
exports.SvgBattery = (props) => {
    const strokeWidth = props.strokeWidth || 2;
    const css = styled_system_1.styledSystem(props.wheel.wrSystemConfig, props.wheel.wrSystemTheme, props.ncss);
    return (core_1.jsx("svg", { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round", className: "battery_svg__feather battery_svg__feather-battery", css: css, id: componentId, width: "100%" },
        core_1.jsx("rect", { x: 1, y: 6, width: 18, height: 12, rx: 2, ry: 2 }),
        core_1.jsx("path", { d: "M23 13v-2" })));
};
//# sourceMappingURL=battery.js.map